import { useState } from "react";
import { useAxios } from "../../../utils/useAxios";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";

/**
 * @typedef {Object} DeleteClassroomParams
 * @property {number} classroomId
 * @property {()=> void} onSuccess
 */

/**
 * Custom hook to delete a classroom, which takes classroomId as parameter and success function
 * which is called when classroom is deleted successfully
 */
export const useDeleteClassroom = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const { axiosInstance } = useAxios();

  /**
   * @param {DeleteClassroomParams} params
   */
  const deleteClassroom = async ({ classroomId, onSuccess }) => {
    setLoading(true);
    setError("");
    setSuccess(false);
    try {
      await axiosInstance.delete(
        `${TENANT_DOMAIN}/classroom/destroy/${classroomId}`,
      );
      setSuccess(true);
      onSuccess();
    } catch (error) {
      if (error?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(error?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    success,
    deleteClassroom,
  };
};

export default useDeleteClassroom;
